import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { PublicLayout } from '../../components/PublicLayout/PublicLayout';
import AssessmentHeaderContent from './AssessmentHeaderContent/AssessmentHeaderContent';

function getClose(language) {
    if (language === 'SPA' || language === 'LAS') {
        return 'Cerrar';
    } else if (language === 'FRE') {
        return 'Fermer';
    } else if (language === 'POR' || language === 'POE') {
        return 'Perto';
    } else if (language === 'CHI') {
        return '关';
    } else if (language === 'CZE') {
        return 'Zavřít';
    } else if (language === 'RUS') {
        return 'Закрыть';
    } else if (language === 'GER') {
        return 'Schließen';
    } else if (language === 'DUT') {
        return 'Dichtbij';
    } else if (language === 'IND') {
        return 'Menutup';
    }
    return 'Close';
}

export const AssessmentLayout = (props) => {
    const close = getClose(props.assessmentLanguage);
    const headerContent = (
        <AssessmentHeaderContent
            firstName={props.firstName}
            lastName={props.lastName}
            progressPercent={props.progressPercent}
            close={close}
            {...props}
        />
    );

    return (
        <PublicLayout
            headerContent={headerContent}
            mainContent={props.mainContent}
        />
    );
};

AssessmentLayout.propTypes = {
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    progressPercent: PropTypes.number,
    assessmentLanguage: PropTypes.string,
    mainContent: PropTypes.oneOfType([
        PropTypes.arrayOf(PropTypes.node),
        PropTypes.node,
    ]),
};

AssessmentLayout.defaultProps = {
    firstName: '',
    lastName: '',
    progressPercent: 0,
    assessmentLanguage: 'ENG',
    mainContent: null,
};

const mapStateToProps = state => ({
    firstName: state?.assessment?.firstName,
    lastName: state?.assessment?.lastName,
    progressPercent: state?.assessment?.progressPercent,
    assessmentLanguage: state?.assessment?.language,
});

export const ConnectedAssessmentLayout = connect(mapStateToProps)(AssessmentLayout);

function withAssessmentLayout(Component) {
    return (props) => {

        const content = (<Component {...props} />);

        return (
            <ConnectedAssessmentLayout
                mainContent={content}
                {...props}
            />
        );
    };
}

export default (withAssessmentLayout);
